import { FC } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import OrderFail from '../../components/OrderFail';
import OrderSuccess from '../../components/OrderSuccess';

interface ICheckoutResultPresentational {
  onRetryPayment: () => void;
  success: boolean;
  wireTransfer: boolean;
}

const CheckoutResultPresentational: FC<ICheckoutResultPresentational> = (
  props
) => {
  const { onRetryPayment = () => {}, success, wireTransfer } = props;

  return (
    <div className="min-h-screen">
      <Header />

      {success ? (
        <OrderSuccess wireTransfer={wireTransfer} />
      ) : (
        <OrderFail onRetryPayment={onRetryPayment} />
      )}

      <Footer />
    </div>
  );
};

export default CheckoutResultPresentational;
